import { render, staticRenderFns } from "./WorkSpeedDialButton.vue?vue&type=template&id=0dc66dd8"
import script from "./WorkSpeedDialButton.vue?vue&type=script&lang=js"
export * from "./WorkSpeedDialButton.vue?vue&type=script&lang=js"
import style0 from "./WorkSpeedDialButton.vue?vue&type=style&index=0&id=0dc66dd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports